import TablePage from '../../../../../../components/pages/TablePage';
import Awbs from './awbs';
import { RiFileTransferLine } from 'react-icons/ri';

export default () => {
    const columns = [
        {
            selector: (row) => row?.flight_number,
            name: "Flight Number"
        },
        {
            selector: (row) => row?.flight_date,
            name: "Flight Date"
        }
    ]
    return (
        <TablePage
            title={"Import Out"}
            url="api/v1/tps_import/import_out"
            actionPosition={'right'}
            columns={columns}
            ExpandComponent={Awbs}
        />
    )
}
